import { render, staticRenderFns } from "./notionScreen.vue?vue&type=template&id=d49b338e&scoped=true&"
import script from "./notionScreen.vue?vue&type=script&lang=js&"
export * from "./notionScreen.vue?vue&type=script&lang=js&"
import style0 from "./notionScreen.vue?vue&type=style&index=0&id=d49b338e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49b338e",
  null
  
)

export default component.exports